import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  constructor(public _appGeneralState: AppGeneralStateService) {}

  ngOnInit(): void {}
}
